import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PublicCustomer } from '../models/public-customer.model';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '@environment';
import { FaqInstanceAdminDTO } from '@settings-models/faq-instance-admin-dto.model';

@Injectable({
    providedIn: 'root',
})
export class ConfigurationService {
    constructor(private httpClient: HttpClient) {}

    getCustomerInfo(): Observable<PublicCustomer> {
        return this.httpClient.get<PublicCustomer>(environment.apiMasterUrl + 'customerByCommunity/');
    }

    getFAQInfo(name = ''): Observable<FaqInstanceAdminDTO> {
        return this.httpClient.get<FaqInstanceAdminDTO>(environment.apiFaqUrl + 'instance/', {
            params: new HttpParams().set('name', name),
        });
    }
}
